/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'

import { getAllCategoryLevel01 } from '../../api/productCategoriesApi'
import { getAllBanners } from '../../api/bannerApi'
import TopBar from '../../components/TopBar'
import styles from './page.module.css'

import search from '../../assets/images/search.svg'
import deleteIcon from '../../assets/images/delete.svg'
import { getOption, updateOption } from '../../api/optionsApi'

export const MobileMenu = () => {
    const [categoryList, setCategoryList] = useState([])
    const [bannerList, setBannerList] = useState([])
    const [topDealList, setTopDealList] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const [selectedCategories, setSelectedCategories] = useState([])
    const [selectedBanners, setSelectedBanners] = useState([])
    const [selectedTopDeals, setSelectedTopDeals] = useState([])

    const [categorySearchInput, setCategorySearchInput] = useState('')
    const [bannerSearchInput, setBannerSearchInput] = useState('')
    const [topDealSearchInput, setTopDealSearchInput] = useState('')

    const [originalCategories, setOriginalCategories] = useState([])
    const [originalBanners, setOriginalBanners] = useState([])
    const [originalTopDeal, setOriginalTopDeal] = useState([])

    const [searchActive, setSearchActive] = useState(true)
    const [showBlock, setShowBlock] = useState('category')

    const [menu, setMenu] = useState([])
    const itemRefs = useRef([])
    const dragIndexRef = useRef(null)
    const placeholderIndexRef = useRef(null)
    const draggedItemsRef = useRef([])
    const startXRef = useRef(0)
    const depthRef = useRef(0)
    const containerRef = useRef(null)
    const visualPlaceholderRef = useRef(null)

    const [dragIndex, setDragIndex] = useState(null)
    const [placeholderIndex, setPlaceholderIndex] = useState(null)
    const [dragY, setDragY] = useState(0)

    const MAX_DEPTH = 0
    const INDENT = 30
    const ROW_HEIGHT = 57
    const DRAG_THRESHOLD = 5

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAllCategoryLevel01()
                const responseBanner = await getAllBanners()

                if (response?.data?.success || responseBanner?.success) {
                    const categories = response?.data?.data || []
                    const banners = responseBanner?.data || []

                    setCategoryList(categories.slice(0, 5))
                    setOriginalCategories(categories)
                    setBannerList(banners.slice(0, 5))
                    setOriginalBanners(banners)
                    setTopDealList(banners.slice(0, 5))
                    setOriginalTopDeal(banners)

                    const responseOptions = await getOption("mobile-menu")

                    if (responseOptions?.success) {
                        const selectedCategoryIds = responseOptions?.data?.value?.category || []
                        const selectedBannerIds = responseOptions?.data?.value?.banner || []
                        const selectedTopDealIds = responseOptions?.data?.value?.topDeal || []

                        const cats = selectedCategoryIds
                            .map(id => categories.find(item => item.categoryId === id))
                            .filter(Boolean)

                        const bannersArr = selectedBannerIds
                            .map(id => banners.find(item => item.bannerId === id))
                            .filter(Boolean)

                        const topDeals = selectedTopDealIds
                            .map(id => banners.find(item => item.bannerId === id))
                            .filter(Boolean)


                        setSelectedCategories(cats)
                        setSelectedBanners(bannersArr)
                        setSelectedTopDeals(topDeals)

                        // Build menu items
                        const menuItems = []
                        cats.forEach(item => {
                            menuItems.push({
                                id: `category-${item.categoryId}`,
                                title: item.name,
                                url_address: '',
                                type: 'category',
                                depth: 0,
                                isOpen: false,
                            })
                        })
                        bannersArr.forEach(item => {
                            menuItems.push({
                                id: `banner-${item.bannerId}`,
                                title: item.bannerTitle,
                                url_address: '',
                                type: 'banner',
                                depth: 0,
                                isOpen: false,
                            })
                        })
                        topDeals.forEach(item => {
                            menuItems.push({
                                id: `topDeal-${item.bannerId}`,
                                title: item.bannerTitle,
                                url_address: '',
                                type: 'topDeal',
                                depth: 0,
                                isOpen: false,
                            })
                        })
                        setMenu(menuItems)
                    }
                }
            } catch (error) {
                console.log({ error })
            }
        }

        fetchData()
    }, [])

    const searchCategories = (e) => {
        setCategorySearchInput(e.target.value)
        setSearchActive(true)
        const input = e.target.value.toLowerCase()
        const result = originalCategories.filter(item =>
            item.name.toLowerCase().startsWith(input)
        )

        if (result.length === originalCategories.length) {
            setCategoryList(originalCategories.slice(0, 5))
        } else if (result != []) {
            setCategoryList(result)
            setSearchActive(false)
        } else {
            setCategoryList([])
            setSearchActive(false)
        }
    }

    const searchBanners = (e) => {
        setBannerSearchInput(e.target.value)
        setSearchActive(true)
        const input = e.target.value.toLowerCase()
        const result = originalBanners.filter(item =>
            item.bannerTitle.toLowerCase().startsWith(input)
        )
        if (result.length === originalBanners.length) {
            setBannerList(originalBanners.slice(0, 5))
        } else if (result != []) {
            setBannerList(result)
            setSearchActive(false)
        } else {
            setBannerList([])
            setSearchActive(false)
        }
    }

    const searchTopDeals = (e) => {
        setTopDealSearchInput(e.target.value)
        setSearchActive(true)
        const input = e.target.value.toLowerCase()
        const result = originalTopDeal.filter(item =>
            item.bannerTitle.toLowerCase().startsWith(input)
        )
        if (result.length === originalTopDeal.length) {
            setTopDealList(originalTopDeal.slice(0, 5))
        } else if (result != []) {
            setTopDealList(result)
            setSearchActive(false)
        } else {
            setTopDealList([])
            setSearchActive(false)
        }
    }

    const handleCategories = (item) => {
        const exists = selectedCategories.some(cat => cat.categoryId === item.categoryId)
        if (exists) {
            const filtered = selectedCategories.filter(cat => cat.categoryId !== item.categoryId)
            setSelectedCategories(filtered.length > 0 ? filtered : [])
            setMenu(prev => prev.filter(m => !(m.type === 'category' && m.id === `category-${item.categoryId}`)))
        } else {
            setSelectedCategories(prev => [...prev, item])
            setMenu(prev => [...prev, {
                id: `category-${item.categoryId}`,
                title: item.name,
                url_address: '',
                type: 'category',
                depth: 0,
                isOpen: false,
            }])
        }
    }

    const handleBanners = (item) => {
        const exists = selectedBanners.some(b => b.bannerId === item.bannerId)
        if (exists) {
            const filtered = selectedBanners.filter(b => b.bannerId !== item.bannerId)
            setSelectedBanners(filtered.length > 0 ? filtered : [])
            setMenu(prev => prev.filter(m => !(m.type === 'banner' && m.id === `banner-${item.bannerId}`)))
        } else {
            setSelectedBanners(prev => [...prev, item])
            setMenu(prev => [...prev, {
                id: `banner-${item.bannerId}`,
                title: item.bannerTitle,
                url_address: '',
                type: 'banner',
                depth: 0,
                isOpen: false,
            }])
        }
    }

    const handleTopDeals = (item) => {
        const exists = selectedTopDeals.some(b => b.bannerId === item.bannerId)
        if (exists) {
            const filtered = selectedTopDeals.filter(b => b.bannerId !== item.bannerId)
            setSelectedTopDeals(filtered.length > 0 ? filtered : [])
            setMenu(prev => prev.filter(m => !(m.type === 'topDeal' && m.id === `topDeal-${item.bannerId}`)))
        } else {
            setSelectedTopDeals(prev => [...prev, item])
            setMenu(prev => [...prev, {
                id: `topDeal-${item.bannerId}`,
                title: item.bannerTitle,
                url_address: '',
                type: 'topDeal',
                depth: 0,
                isOpen: false,
            }])
        }
    }

    const getSubtree = (list, index) => {
        const rootDepth = list[index].depth
        const items = [list[index]]
        for (let i = index + 1; i < list.length; i++) {
            if (list[i].depth <= rootDepth) break
            items.push(list[i])
        }
        return items
    }

    const getPlaceholderHeight = () => {
        return (draggedItemsRef.current.length * ROW_HEIGHT) + ((draggedItemsRef.current.length - 1) * 10)
    }

    const getMaxAllowedDepth = (insertIndex) => {
        if (insertIndex === 0) return 0
        let maxDepth = 0
        for (let i = insertIndex - 1; i >= 0; i--) {
            const item = menu[i]
            if (
                dragIndexRef.current !== null &&
                i >= dragIndexRef.current &&
                i < dragIndexRef.current + draggedItemsRef.current.length
            ) {
                continue
            }
            maxDepth = item.depth + 1
            break
        }
        return Math.min(maxDepth, MAX_DEPTH)
    }

    const getSubtreeDepthSpan = (subtree) => {
        let max = 0
        subtree.forEach(item => {
            max = Math.max(max, item.depth - subtree[0].depth)
        })
        return max
    }

    const clampDepthWithSubtree = (desiredDepth, insertIndex) => {
        const subtree = draggedItemsRef.current
        const subtreeSpan = getSubtreeDepthSpan(subtree)
        const baseAllowed = getMaxAllowedDepth(insertIndex)
        const maxAllowed = Math.min(baseAllowed, MAX_DEPTH - subtreeSpan)
        return Math.max(0, Math.min(desiredDepth, maxAllowed))
    }

    const handleMouseDown = (e, index) => {
        e.preventDefault()
        dragIndexRef.current = index
        placeholderIndexRef.current = index
        draggedItemsRef.current = getSubtree(menu, index)
        depthRef.current = menu[index].depth
        startXRef.current = e.clientX
        setDragIndex(index)
        setPlaceholderIndex(index)
        setDragY(e.clientY)
        document.addEventListener("mousemove", handleMouseMove)
        document.addEventListener("mouseup", handleMouseUp)
    }

    const handleRowMouseDown = (e, index) => {
        const startX = e.clientX
        const startY = e.clientY

        const onMove = (moveEvent) => {
            const dx = Math.abs(moveEvent.clientX - startX)
            const dy = Math.abs(moveEvent.clientY - startY)
            if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
                handleMouseDown(e, index)
            }
        }

        const onUp = () => {
            document.removeEventListener("mousemove", onMove)
            document.removeEventListener("mouseup", onUp)
        }

        document.addEventListener("mousemove", onMove)
        document.addEventListener("mouseup", onUp)
    }

    const handleMouseMove = (e) => {
        setDragY(e.clientY)
        const containerRect = containerRef.current?.getBoundingClientRect()
        if (!containerRect) return
        const relativeY = e.clientY - containerRect.top
        setDragY(relativeY)
        let newPlaceholder = menu.length
        for (let i = 0; i < itemRefs.current.length; i++) {
            if (
                dragIndexRef.current !== null &&
                i >= dragIndexRef.current &&
                i < dragIndexRef.current + draggedItemsRef.current.length
            ) {
                continue
            }
            const el = itemRefs.current[i]
            if (!el) continue
            const rect = el.getBoundingClientRect()
            if (e.clientY < rect.top + rect.height / 2) {
                newPlaceholder = i
                break
            }
        }
        placeholderIndexRef.current = newPlaceholder
        visualPlaceholderRef.current = newPlaceholder
        setPlaceholderIndex(newPlaceholder)
        const deltaX = e.clientX - startXRef.current
        let desiredDepth = depthRef.current
        if (deltaX > INDENT) {
            desiredDepth++
            startXRef.current = e.clientX
        } else if (deltaX < -INDENT) {
            desiredDepth--
            startXRef.current = e.clientX
        }
        depthRef.current = clampDepthWithSubtree(desiredDepth, newPlaceholder)
    }

    const handleMouseUp = () => {
        const from = dragIndexRef.current
        const to = placeholderIndexRef.current
        if (from !== null && to !== null) {
            const updated = [...menu]
            const subtree = draggedItemsRef.current
            const count = subtree.length
            updated.splice(from, count)
            let insertAt = to
            if (to > from) insertAt -= count
            const visualIndex = visualPlaceholderRef.current
            const finalDepth = clampDepthWithSubtree(depthRef.current, visualIndex)
            const depthDiff = finalDepth - subtree[0].depth
            const adjusted = subtree.map((item) => ({
                ...item,
                depth: item.depth + depthDiff,
            }))
            updated.splice(insertAt, 0, ...adjusted)
            setMenu(updated)
        }
        cleanup()
    }

    const cleanup = () => {
        dragIndexRef.current = null
        placeholderIndexRef.current = null
        draggedItemsRef.current = []
        setDragIndex(null)
        setPlaceholderIndex(null)
        document.removeEventListener("mousemove", handleMouseMove)
        document.removeEventListener("mouseup", handleMouseUp)
    }

    const handleSubmit = async () => {
        setIsLoading(true)
        const payload = {
            banner: [],
            topDeal: [],
            category: [],
        }

        menu.forEach(item => {
            if (item.type === 'category') {
                const catId = Number(item.id.replace('category-', ''))
                payload.category.push(catId)
            }

            if (item.type === 'banner') {
                const bannerId = Number(item.id.replace('banner-', ''))
                payload.banner.push(bannerId)
            }

            if (item.type === 'topDeal') {
                const topDealId = Number(item.id.replace('topDeal-', ''))
                payload.topDeal.push(topDealId)
            }
        })


        try {
            await updateOption("mobile-menu", payload);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setIsLoading(false)
        }
    }

    const filteredMenu = showBlock
        ? menu?.filter(item => item?.type === showBlock)
        : menu?.filter(item => item?.type === 'category');

    const deleteMenuItem = (item) => {
        setMenu(prev => prev.filter(m => m.id !== item.id))

        if (item.type === 'category') {
            setSelectedCategories(prev =>
                prev.filter(cat => `category-${cat.categoryId}` !== item.id)
            )
        }

        if (item.type === 'banner') {
            setSelectedBanners(prev =>
                prev.filter(b => `banner-${b.bannerId}` !== item.id)
            )
        }

        if (item.type === 'topDeal') {
            setSelectedTopDeals(prev =>
                prev.filter(b => `topDeal-${b.bannerId}` !== item.id)
            )
        }
    }


    const menuTitleMap = {
        category: 'Category Navigation Menu',
        banner: 'Banner Section',
        topDeal: 'Top Deals Section',
    }   

    return (
        <>
            <TopBar />
            <div className={styles.settingsMenuList}>
                <div className={styles.settingsListWrap}>
                    {/* Left Side - Select to add the navigation menu */}
                    <div className={styles.navLeftList}>
                        <p className={`${styles.settingsMenuBlockTitle} ${styles.titleBottom}`}>
                            Select to add the navigation menu for mobile
                        </p>

                        <div className={styles.navigationLeft}>
                            {/* Categories */}
                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "category" ? "active" : ""}`}
                                    onClick={() => setShowBlock("category")}
                                >
                                    Categories
                                </p>
                                <motion.div
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "category" ? 1 : 0,
                                        height: showBlock === "category" ? "auto" : 0,
                                        paddingBottom: showBlock === "category" ? "15px" : 0,
                                    }}
                                >
                                    <div className={styles.navigationTop}>
                                        <div className={styles.pageSearchInput}>
                                            <input
                                                type="text"
                                                placeholder="Search categories..."
                                                value={categorySearchInput}
                                                onChange={searchCategories}
                                            />
                                            <img src={search} alt="Search" />
                                        </div>
                                    </div>
                                    <div className={styles.settingsMenuPages}>
                                        {categoryList.length > 0 ? (
                                            categoryList.map((item, index) => {
                                                const isSelected = selectedCategories.some(cat => cat.categoryId === item.categoryId)
                                                return (
                                                    <div key={index} className={styles.settingsMenuItem}>
                                                        <input
                                                            type="checkbox"
                                                            id={`menu-item-category-${item.categoryId}`}
                                                            checked={isSelected}
                                                            onChange={() => handleCategories(item)}
                                                        />
                                                        <label htmlFor={`menu-item-category-${item.categoryId}`}>{item.name}</label>
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <p className={styles.nothingFound}>Nothing found!</p>
                                        )}
                                        {searchActive && categoryList.length < originalCategories.length && (
                                            <p className={styles.showMorePages} onClick={() => setCategoryList(originalCategories)}>
                                                Show {originalCategories.length - categoryList.length} more
                                            </p>
                                        )}
                                    </div>
                                </motion.div>
                            </div>

                            {/* Banners */}
                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "banner" ? "active" : ""}`}
                                    onClick={() => setShowBlock("banner")}
                                >
                                    Banners
                                </p>
                                <motion.div
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "banner" ? 1 : 0,
                                        height: showBlock === "banner" ? "auto" : 0,
                                        paddingBottom: showBlock === "banner" ? "15px" : 0,
                                    }}
                                >
                                    <div className={styles.navigationTop}>
                                        <div className={styles.pageSearchInput}>
                                            <input
                                                type="text"
                                                placeholder="Search banners..."
                                                value={bannerSearchInput}
                                                onChange={searchBanners}
                                            />
                                            <img src={search} alt="Search" />
                                        </div>
                                    </div>
                                    <div className={styles.settingsMenuPages}>
                                        {bannerList.length > 0 ? (
                                            bannerList.map((item, index) => {
                                                const isSelected = selectedBanners.some(b => b.bannerId === item.bannerId)
                                                return (
                                                    <div key={index} className={styles.settingsMenuItem}>
                                                        <input
                                                            type="checkbox"
                                                            id={`menu-item-banner-${item.bannerId}`}
                                                            checked={isSelected}
                                                            onChange={() => handleBanners(item)}
                                                        />
                                                        <label htmlFor={`menu-item-banner-${item.bannerId}`}>{item.bannerTitle}</label>
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <p className={styles.nothingFound}>Nothing found!</p>
                                        )}
                                        {searchActive && bannerList.length < originalBanners.length && (
                                            <p className={styles.showMorePages} onClick={() => setBannerList(originalBanners)}>
                                                Show {originalBanners.length - bannerList.length} more
                                            </p>
                                        )}
                                    </div>
                                </motion.div>
                            </div>

                            {/* Top Deals */}
                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "topDeal" ? "active" : ""}`}
                                    onClick={() => setShowBlock("topDeal")}
                                >
                                    Top Deals
                                </p>
                                <motion.div
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "topDeal" ? 1 : 0,
                                        height: showBlock === "topDeal" ? "auto" : 0,
                                        paddingBottom: showBlock === "topDeal" ? "15px" : 0,
                                    }}
                                >
                                    <div className={styles.navigationTop}>
                                        <div className={styles.pageSearchInput}>
                                            <input
                                                type="text"
                                                placeholder="Search top deals..."
                                                value={topDealSearchInput}
                                                onChange={searchTopDeals}
                                            />
                                            <img src={search} alt="Search" />
                                        </div>
                                    </div>
                                    <div className={styles.settingsMenuPages}>
                                        {topDealList.length > 0 ? (
                                            topDealList.map((item, index) => {
                                                const isSelected = selectedTopDeals.some(b => b.bannerId === item.bannerId)
                                                return (
                                                    <div key={index} className={styles.settingsMenuItem}>
                                                        <input
                                                            type="checkbox"
                                                            id={`menu-item-topDeal-${item.bannerId}`}
                                                            checked={isSelected}
                                                            onChange={() => handleTopDeals(item)}
                                                        />
                                                        <label htmlFor={`menu-item-topDeal-${item.bannerId}`}>{item.bannerTitle}</label>
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <p className={styles.nothingFound}>Nothing found!</p>
                                        )}
                                        {searchActive && topDealList.length < originalTopDeal.length && (
                                            <p className={styles.showMorePages} onClick={() => setTopDealList(originalTopDeal)}>
                                                Show {originalTopDeal.length - topDealList.length} more
                                            </p>
                                        )}
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - My Navigation Menu */}
                    <div className={styles.navigationRight}>
                        <p className={styles.settingsMenuBlockTitle}>{menuTitleMap[showBlock] || 'Category Navigation Menu'}</p>
                        <div className={styles.navRightList}>
                            <div className={styles.menuSorter} ref={containerRef}>
                                {filteredMenu?.length > 0 && filteredMenu?.map((item, index) => {
                                    const realIndex = menu.findIndex(m => m.id === item.id)
                                    const isDraggingSubtree =
                                        dragIndex !== null &&
                                        realIndex >= dragIndex &&
                                        realIndex < dragIndex + draggedItemsRef.current.length
                                    return (
                                        <div key={`menu-item-row-${item.type}-${item.id}`}>
                                            {placeholderIndex === realIndex && dragIndex !== null && (
                                                <div
                                                    className={styles.placeholder}
                                                    style={{
                                                        height: getPlaceholderHeight(),
                                                        marginLeft: depthRef.current > 0 ? depthRef.current * INDENT : 0,
                                                    }}
                                                />
                                            )}
                                            <div
                                                className={`${styles.menuItemRow} ${isDraggingSubtree ? styles.hidden : ""}`}
                                                style={{ marginLeft: item.depth > 0 ? item.depth * INDENT : 0 }}
                                            >
                                                <div
                                                    ref={(el) => (itemRefs.current[realIndex] = el)}
                                                    className={styles.menuItem}
                                                    onMouseDown={(e) => handleRowMouseDown(e, realIndex)}
                                                >
                                                    <span
                                                        className={styles.dragIcon}
                                                        onMouseDown={(e) => {
                                                            e.stopPropagation();
                                                            handleMouseDown(e, realIndex);
                                                        }}
                                                    >
                                                        ⇅
                                                    </span>
                                                    <span className={styles.menuTitleFront}>{item.title}</span>
                                                    <button
                                                        className={styles.removeItemBtn}
                                                        onClick={() => deleteMenuItem(item)}
                                                    >
                                                        <img src={deleteIcon} alt="Remove" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                                {placeholderIndex === filteredMenu.length && dragIndex !== null && (
                                    <div
                                        className={styles.placeholder}
                                        style={{
                                            height: getPlaceholderHeight(),
                                            marginLeft: depthRef.current > 0 ? depthRef.current * INDENT : 0,
                                        }}
                                    />
                                )}

                                {dragIndex !== null && (
                                    <div className={styles.dragPreview} style={{ top: dragY - 28 }}>
                                        {draggedItemsRef.current.map((item, i) => (
                                            <div
                                                key={item.id}
                                                className={styles.dragPreviewItem}
                                                style={{ marginLeft: item.depth * INDENT }}
                                            >
                                                <span className={styles.dragIcon}>⇅</span>
                                                <span className={styles.dragPreviewItemTitle}>{item.title}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {filteredMenu.length > 0 && (
                    <div className={styles.saveButtons}>
                        <button
                            className={styles.saveButton}
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? <div className={`ringLoader`}></div> : 'Save'}
                        </button>
                    </div>
                )}
            </div>
        </>
    )
}
